import { shallowEqual } from 'react-redux';

import { NsCard } from 'components/common/ns-card/NsCard';
import { NsContent } from 'components/common/ns-content/NsContent';
import { NsDescriptionList } from 'components/common/ns-description-list/NsDescriptionList';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';

import { useAppSelector } from 'hooks/useAppSelector';
import { useNavigation } from 'hooks/useNavigation';
import { useApplicant } from 'components/direct-sales/order-summary/hooks/useApplicant';
import { useMaskPII } from 'hooks/useMaskPII';

import { selectMeterReadPreferences } from 'state/user-preferences/user-preferences-slice';
import { capitalize } from 'utils/misc';
import { formatDate } from 'components/direct-sales/quote/utils';

import { METER_READ_TYPES_FOR_DISPLAY } from 'config/app-config';

export const OrderSummaryPersonalDetails = () => {
  const { mask } = useMaskPII();
  // Get the applicant details
  const personalDetails = useApplicant();

  // Get the meter reading preferences
  const meterReadPreference = useAppSelector(
    selectMeterReadPreferences,
    shallowEqual
  );
  const meterReadingPreferenceValue =
    meterReadPreference.electric || meterReadPreference.gas || false;

  const { eventTypes, next } = useNavigation();

  // Get the marketing preferences
  const marketingPreferences: string[] = [];
  Object.keys(personalDetails.marketingChannelPreference).reduce((acc, key) => {
    if (personalDetails.marketingChannelPreference[key]) {
      acc.push(capitalize(key));
    }
    return acc;
  }, marketingPreferences);

  const changePersonalDetails = () => {
    next({ eventType: eventTypes.CHANGE_PERSONAL_DETAILS, wasVisited: true });
  };

  return (
    <>
      <NsContent spacing="normal">
        <h2 className="h4">Your personal details</h2>
      </NsContent>

      <NsCard>
        <NsDescriptionList>
          {[
            {
              term: 'About you',
              description: [
                <>
                  <p {...mask}>
                    {personalDetails.title} {personalDetails.firstName}{' '}
                    {personalDetails.lastName}
                  </p>
                  <p {...mask}>{formatDate(personalDetails.dateOfBirth)}</p>
                  <p {...mask}>
                    {personalDetails.emailAddresses?.[0].emailAddress}
                  </p>
                  <p {...mask}>
                    {personalDetails.telephoneNumbers?.[0].telephoneNumber}
                  </p>
                </>
              ]
            },
            ...(marketingPreferences.length
              ? [
                  {
                    term: 'Marketing preferences',
                    description: [
                      <>{marketingPreferences.join(', ')}</>,
                      ...(!meterReadingPreferenceValue
                        ? [
                            <>
                              <br />
                              <NsSecondaryCta icon="">
                                Edit personal details
                              </NsSecondaryCta>
                            </>
                          ]
                        : [])
                    ]
                  }
                ]
              : []),
            meterReadingPreferenceValue && {
              term: 'Meter reading',
              description: [
                <>
                  {METER_READ_TYPES_FOR_DISPLAY[meterReadingPreferenceValue]}{' '}
                  frequency
                </>,
                <>
                  <br />
                  <NsSecondaryCta onClick={changePersonalDetails} icon="">
                    Edit personal details
                  </NsSecondaryCta>
                </>
              ]
            }
          ]}
        </NsDescriptionList>
      </NsCard>
    </>
  );
};

export default OrderSummaryPersonalDetails;
